export const CarrierRoutes = [
    {
        name: "carrier-detail",
        path: "/carrier/:carrierId?",
        component: () => import("@/app/carriers/Carrier"),
        props: true
    },
    {
        name: "carrier-list",
        path: "/carriers",
        component: () => import("@/app/carriers/CarrierList"),
        props: true
    }
]